module.exports = __webpack_public_path__ + "static/img/dizajn911.bb5c942.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/dizajn911.png
// module id = CVit
// module chunks = 0